import axios from 'axios';

const eventsservice = axios.create({
  baseURL: `${process.env.REACT_APP_AUTH_SERVICE_BASE_URL}public/events/`,
});

const questionnaireservice = axios.create({
  baseURL: `${process.env.REACT_APP_QUESTIONNAIRE_SERVICE_BASE_URL}/api/v1/public`,
});

const getEventDetails = (id: string) =>
  eventsservice.get(`${id}`).catch((err) => {
    return err;
  });

const sendRegistrationDetails = (eventKey: any, body: any) => {
  return eventsservice.post(`${eventKey}/registrations`, body);
};

const getUserDetails = (body: any) => {
  return eventsservice.get(`registrations/${body.eventRegistrationId}`);
};

const getConferenceRegistration = (body: any) => {
  return eventsservice.post(
    `registrations/${body.eventRegistrationId}/conferences/${body.conferenceKey}`,
  );
};

const cancelRegisteredEvent = (eventRegistrationId: string) =>
  eventsservice.delete(`registrations/${eventRegistrationId}`);

const getQuestionnaire = (questionnaireKey: string, locale: string) => {
  const options = {
    headers: { 'Accept-Language': locale },
  };
  return questionnaireservice.get(`/questionnaires/${questionnaireKey}`, options);
};

const API = {
  getEventDetails,
  sendRegistrationDetails,
  getUserDetails,
  getConferenceRegistration,
  cancelRegisteredEvent,
  getQuestionnaire,
};

export default API;
